import { api } from "@/lib/api";
import type { SupportNote } from "@/lib/schema";

export const SupportNoteService = {
  async list(appUserId: string): Promise<SupportNote[]> {
    return api.get<SupportNote[]>(`/api/app-users/${appUserId}/notes`);
  },

  async add(appUserId: string, content: string): Promise<SupportNote> {
    return api.post<SupportNote>(`/api/app-users/${appUserId}/notes`, {
      content,
    });
  },
};
